import axios from 'axios';
import { getAccessTokenApi, getRefreshTokenApi, refreshAccessTokenApi, logout } from './auth';
import { getCurrentSubdomain } from './tenantResolver';

let refreshPromise = null;

const attachHeaders = (config) => {
  const token = getAccessTokenApi();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = token;
  }
  // El back necesita el subdominio cuando el front vive en CF Pages y el
  // Host del request al API es api.stiltech.cl (común a todos los tenants).
  const subdomain = getCurrentSubdomain();
  if (subdomain) {
    config.headers = config.headers || {};
    config.headers['X-Tenant-Subdomain'] = subdomain;
  }
  return config;
};

const refreshOnce = () => {
  if (!refreshPromise) {
    const refreshToken = getRefreshTokenApi();
    if (!refreshToken) {
      return Promise.resolve(false);
    }
    refreshPromise = refreshAccessTokenApi(refreshToken).finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
};

export const installAxiosInterceptors = () => {
  axios.interceptors.request.use(attachHeaders);

  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const original = error.config;
      const status = error.response?.status;

      if (status !== 401 || !original || original._retry) {
        return Promise.reject(error);
      }

      original._retry = true;
      const refreshed = await refreshOnce();

      if (!refreshed) {
        logout();
        return Promise.reject(error);
      }

      const newToken = getAccessTokenApi();
      if (!newToken) {
        return Promise.reject(error);
      }

      original.headers = original.headers || {};
      original.headers.Authorization = newToken;
      return axios(original);
    }
  );
};
